/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UserService {
  public currentBusinessUnitId: any;
  public currentBusinessUnitDetail;
  public currentBusinessUnitDetailBS = new BehaviorSubject({});
  public currentBusinessUnitDetailOb = this.currentBusinessUnitDetailBS.asObservable();
  public isMembersDetailedView = false;
  public canReloadMembers = false;
  constructor() {}

  setCurrentBusinessUnit(businessUnit: any) {
    this.currentBusinessUnitDetail = businessUnit;
    this.currentBusinessUnitDetailBS.next(businessUnit);
  }
  returnPageText(pageNumber, totalCount) {
    let pageText = "";
    if (pageNumber * 10 - 9 === totalCount) {
      pageText = "Result " + (pageNumber * 10 - 9) + " of " + totalCount;
    } else {
      pageText =
        "Result " +
        (pageNumber * 10 - 9) +
        " to " +
        (pageNumber * 10 < totalCount ? pageNumber * 10 : totalCount) +
        " of " +
        totalCount;
    }
    return pageText;
  }
}
